var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObelinkAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "#0032A0",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5626_347)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8666 36.1641L34.3098 32.6023L35.8682 29.0425L37.4253 32.6023L35.8666 36.1641Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7153 31.399L32.1585 27.8372L33.7169 24.2773L35.274 27.8372L33.7153 31.399Z",
    fill: "#4FC100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5645 36.1641L30.0077 32.6023L31.5661 29.0425L33.1232 32.6023L31.5645 36.1641Z",
    fill: "#4FC100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2591 36.1641L25.7023 32.6023L27.2606 29.0425L28.8178 32.6023L27.2591 36.1641Z",
    fill: "#4FC100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4692 36.1641L42.9124 32.6023L44.4708 29.0425L46.028 32.6023L44.4692 36.1641Z",
    fill: "#4FC100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4258 37.0063L25.1684 34.1317L23.6112 37.6892C24.4677 37.4337 25.4102 37.2043 26.4258 37.0063Z",
    fill: "#4FC100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4032 36.4314L29.3974 34.1317L28.2767 36.6917C28.9613 36.5913 29.6717 36.5044 30.4032 36.4314Z",
    fill: "#4FC100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.108 37.6987L48.1111 37.6916L46.554 34.1313L45.2938 37.0111C46.3066 37.2103 47.2495 37.4412 48.108 37.6987Z",
    fill: "#4FC100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0197 41.5598H43.8668V47.6474H41.0197V41.5598ZM41.1003 40.1909C41.1003 39.6493 41.704 39.2101 42.4581 39.2101C43.1928 39.2101 43.8063 39.6493 43.8063 40.1909C43.8063 40.7321 43.1928 41.1713 42.4581 41.1713C41.704 41.1713 41.1003 40.7321 41.1003 40.1909Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8666 36.1641L34.3098 32.6023L35.8682 29.0425L37.4253 32.6023L35.8666 36.1641Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0171 31.399L36.4603 27.8372L38.0187 24.2773L39.5759 27.8372L38.0171 31.399Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.168 36.1641L38.6112 32.6023L40.1696 29.0425L41.7267 32.6023L40.168 36.1641Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6522 36.178L33.757 34.1315L32.8317 36.2459C33.4284 36.2141 34.0356 36.1911 34.6522 36.178Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4996 36.7016L42.3754 34.1313L41.3672 36.4346C42.0999 36.5096 42.8119 36.5989 43.4996 36.7016Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0124 47.719C22.0649 47.7087 21.5018 46.5648 21.5018 44.8384V39.1388H23.9863V41.8047C24.7811 41.3758 25.2336 41.2429 25.7467 41.2429C27.8693 41.2429 28.5535 42.8363 28.5535 44.4809C28.5535 46.3093 27.4367 47.7293 25.0124 47.719ZM25.7869 45.5943C25.8272 45.4308 25.8979 45.1348 25.8979 44.6646C25.8979 44.144 25.8272 43.9088 25.7267 43.5513C25.6361 43.2347 25.3243 42.9081 24.8214 42.9081C24.4494 42.9081 24.1774 43.0509 24.0265 43.2553L24.0066 45.6966C24.1574 45.9518 24.3685 46.1664 24.8214 46.1664C25.3243 46.1664 25.6865 45.9518 25.7869 45.5943Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8762 45.0633C32.1377 46.0643 33.1438 46.1254 33.7273 46.1254C34.3712 46.1254 35.0351 46.0846 35.7092 45.9624V47.4741C34.9644 47.6475 34.1497 47.7089 33.3549 47.7089C30.7497 47.7089 29.2909 46.7079 29.2909 44.4911C29.2909 42.4688 30.3671 41.2432 32.8418 41.2432C35.0551 41.2432 36.0812 42.3156 36.0812 44.1543C36.0812 44.4503 36.0613 44.7466 36.0206 45.0633H31.8762ZM31.8258 43.9091H33.8277C33.7874 43.2552 33.6467 42.7854 32.8621 42.7854C32.0173 42.7854 31.9364 43.1941 31.8258 43.9091Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1317 47.6475H39.9483V39.149H37.1317V47.6475Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7182 43.6842V47.6475H49.2033V43.7251C49.2033 43.2347 48.9316 42.9081 48.2876 42.9081C47.6338 42.9081 47.372 43.2247 47.372 43.7251V47.6475H44.8774V43.6842C44.8774 41.8761 46.2153 41.2532 48.2876 41.2532C50.3298 41.2532 51.7182 41.907 51.7182 43.6842Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4244 45.0224V47.6475H52.7589V39.2002H55.4244V44.0214L56.5109 41.9478H59.3076L58.1004 44.2257L59.6495 47.6475H56.7927L55.4244 44.7467V45.0224Z",
    fill: "#0032A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1818 43.817C12.1818 41.2531 13.3588 39.864 16.4775 39.864C19.6059 39.864 20.7629 41.2531 20.7629 43.817C20.7629 46.4115 19.6563 47.7396 16.4775 47.7396C13.3791 47.7396 12.1818 46.35 12.1818 43.817ZM16.4673 41.7332C15.7229 41.7332 15.3505 42.0602 15.1899 42.4994C15.1192 42.7037 15.0891 42.9386 15.0789 43.1529V43.8067V44.4709C15.0891 44.6955 15.1192 44.9304 15.1899 45.1446C15.3407 45.5942 15.7331 45.9314 16.4974 45.9314C17.2519 45.9314 17.6243 45.5843 17.7752 45.1347C17.8455 44.9201 17.8654 44.6852 17.8858 44.4606C17.8959 44.2356 17.8858 44.0111 17.8858 43.8067C17.8858 43.5822 17.8959 43.3572 17.8858 43.1429C17.8654 42.918 17.8455 42.6831 17.7752 42.4787C17.6142 42.0395 17.232 41.7332 16.4673 41.7332Z",
    fill: "#0032A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5626_347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 24,
    fill: "white",
    transform: "translate(12 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObelinkAppIcon);
export default __webpack_public_path__ + "static/media/obelink-app-icon.00892ea5b11b06adca5387a8314bfb84.svg";
export { ForwardRef as ReactComponent };